import React from "react";
import { useLocation } from "react-router-dom";

/**
 * RouteFallback shows a subtle top progress bar + a centered spinner with an optional message.
 * - If on /auth routes, message is "Authenticating..."
 * - Otherwise, shows a generic "Loading..." text
 */
const RouteFallback: React.FC = () => {
  const location = useLocation();
  const isAuth = location.pathname.startsWith("/auth");
  const message = isAuth ? "Authenticating..." : "Loading...";

  return (
    <>
      <div
        aria-live="polite"
        aria-busy="true"
        style={{
          position: "fixed",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          pointerEvents: "none",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
          {/* Spinner */}
          <div
            role="progressbar"
            aria-label={message}
            style={{
              width: 28,
              height: 28,
              borderRadius: "50%",
              border: "3px solid rgba(59,130,246,0.25)",
              borderTopColor: "rgba(59,130,246,0.95)",
              animation: "route-spinner-rotate 0.8s linear infinite",
            }}
          />
          <div style={{ fontSize: 14, color: "#374151", opacity: 0.75 }}>{message}</div>
        </div>
      </div>
      <style>{`
        @keyframes route-spinner-rotate {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
};

export default RouteFallback;
